import { InjectionToken, Provider, Type, inject } from '@angular/core';
import { DeviceType, Organization, TecComUser } from 'shared-states';
import { NavigationTarget } from '../navigation-target';
import { PortalRegion } from '../portal-region';

/** Everything a landing rule may base its decision on. */
export interface LandingContext {
  readonly user?: TecComUser;
  readonly organizations: readonly Organization[];
  readonly selectedOrganization?: Organization;
  readonly deviceType?: DeviceType;
  readonly region: PortalRegion;
}

/** One step of the User Journey: returns the landing target, or `null` when the rule does not apply. */
export interface LandingRule {
  resolve(context: LandingContext): NavigationTarget | null | Promise<NavigationTarget | null>;
}

export const LANDING_RULES = new InjectionToken<readonly LandingRule[]>('LANDING_RULES');

/** Registers the rules in the given order, which is the order of evaluation. */
export function provideLandingRules(...rules: Type<LandingRule>[]): Provider {
  return { provide: LANDING_RULES, useFactory: () => rules.map(rule => inject(rule)) };
}
